import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import './Auth.css';

import { API_BASE } from '../config/api';
import { jsonHeaders, parseApiError } from '../utils/apiClient';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [otp, setOtp] = useState(searchParams.get('otp') || '');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [message, setMessage] = useState('');

  const verifyEmail = async (emailValue, otpValue) => {
    const response = await fetch(
      `${API_BASE}/users/verify-email?email=${encodeURIComponent(emailValue)}&otp=${encodeURIComponent(otpValue)}`,
      { method: 'POST', headers: jsonHeaders }
    );

    if (response.ok) {
      return { success: true };
    }

    return { success: false, error: await parseApiError(response) };
  };

  useEffect(() => {
    const emailParam = searchParams.get('email');
    const otpParam = searchParams.get('otp');
    if (emailParam && otpParam) {
      setLoading(true);
      verifyEmail(emailParam, otpParam).then((result) => {
        if (result.success) {
          setMessage('Email verified successfully! Redirecting to login...');
          setTimeout(() => navigate('/login'), 2000);
        } else {
          setMessage(result.error);
        }
        setLoading(false);
      });
    }
  }, [searchParams, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const result = await verifyEmail(email, otp);
      if (result.success) {
        setMessage('Email verified successfully! You can now login.');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setMessage(result.error);
      }
    } catch (error) {
      setMessage('Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!email) {
      setMessage('Please enter your email address');
      return;
    }

    setResending(true);
    setMessage('');

    try {
      const response = await fetch(
        `${API_BASE}/users/resend-otp?email=${encodeURIComponent(email)}`,
        { method: 'POST', headers: jsonHeaders }
      );

      if (response.ok) {
        setMessage('A new OTP has been sent to your email');
      } else {
        setMessage(await parseApiError(response));
      }
    } catch (error) {
      setMessage('Failed to resend OTP. Please try again.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-page">
      <Navigation />
      <div className="auth-container">
        <form onSubmit={handleSubmit} className="auth-form">
          <h2>Verify Email</h2>
          <p>Enter the OTP sent to your email address</p>

          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value.toUpperCase())}
            required
            maxLength={10}
            autoComplete="one-time-code"
          />

          <button type="submit" disabled={loading || resending}>
            {loading ? 'Verifying...' : 'Verify Email'}
          </button>

          {message && (
            <p className={`message ${message.includes('success') || message.includes('sent') ? 'success' : 'error'}`}>
              {message}
            </p>
          )}

          <p className="auth-toggle">
            Didn't receive the code?{' '}
            <button
              type="button"
              className="toggle-link logout-btn"
              onClick={handleResendOtp}
              disabled={loading || resending}
            >
              {resending ? 'Sending...' : 'Resend OTP'}
            </button>
          </p>

          <p className="auth-toggle">
            Already verified?{' '}
            <a href="/login" className="toggle-link">
              Login here
            </a>
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default VerifyEmail;
